import React from 'react';
import Button from '../Components/Buttons';

export function Tabs({ children, activeTab, onTabChange }) {
    return (
        <div>
            <div className="tabs mb-5">
                {React.Children.map(children, (child) => (
                    <Button
                        variant={child.props.value === activeTab ? 'primary' : 'secondary'}
                        size='large'
                        onClick={() => onTabChange(child.props.value)}
                    >
                        {child.props.label}
                    </Button>
                ))}
            </div>
            <div className="tab-content d-flex w-100">
                {React.Children.map(children, (child) =>
                    child.props.value === activeTab ? child : null
                )}
            </div>
        </div>
    );
}

export function Tab({ children }) {
    return <div className='d-flex wrap-text w-100'>{children}</div>;
}
